import { getStatusColor } from '~/entities/RepairOrder'
import { repairOrderStatusEnumLabels } from '~/shared/config/constants'
import { TMS_DOMAIN } from '~/shared/config/env'
import { mileageFormat, priceFormat } from '~/shared/lib/utils'
import {
  AsyncGridColumns,
  ColumnDate,
  ColumnLink,
  ColumnValue,
} from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.number',
    field: 'number',
    minWidth: 160,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.number}</ColumnLink>,
  },
  {
    headerName: 'column.date and time',
    field: 'createdAt',
    renderCell: ({ value }) => <ColumnDate value={value} type='dateTime' />,
    minWidth: 200,
  },
  {
    headerName: 'column.car',
    field: 'carPlateNumber',
    sortable: false,
    minWidth: 160,
    renderCell: ({ row }) => (
      <ColumnLink href={`${TMS_DOMAIN}cars/${row.carExtId}`}>
        {row.carPlateNumber}
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.subdivision',
    field: 'carSubdivision',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.mileage',
    field: 'mileage',
    sortable: false,
    minWidth: 180,
    renderCell: ({ value }) => (
      <ColumnValue>{mileageFormat(value)}</ColumnValue>
    ),
  },

  {
    headerName: 'column.user',
    field: 'userName',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.repair order status',
    field: 'status',
    sortable: false,
    minWidth: 210,
    renderCell: ({ row }) => {
      return (
        <ChipStatus
          labelI18n={repairOrderStatusEnumLabels[row.status]}
          variant={getStatusColor(row.status)}
        />
      )
    },
  },
  {
    headerName: 'column.repair type',
    field: 'repairTypes',
    sortable: false,
    minWidth: 220,
  },
  {
    headerName: 'column.counterparty',
    field: 'counterpartyName',
    sortable: false,
    minWidth: 160,
  },
  {
    headerName: 'column.materials cost',
    field: 'materialsCost',
    renderCell: ({ value }) => <ColumnValue>{priceFormat(value)}</ColumnValue>,
    minWidth: 160,
  },
  {
    headerName: 'column.work cost',
    field: 'workCost',
    renderCell: ({ value }) => <ColumnValue>{priceFormat(value)}</ColumnValue>,
    minWidth: 160,
  },
  {
    headerName: 'column.total cost',
    field: 'totalCost',
    renderCell: ({ value }) => <ColumnValue>{priceFormat(value)}</ColumnValue>,
    minWidth: 160,
  },
  {
    headerName: 'column.counterparty number',
    field: 'counterpartyNumber',
    minWidth: 250,
  },
  {
    headerName: 'column.reason',
    field: 'reason',
    minWidth: 250,
    renderCell: ({ value }) => <ColumnValue>{value}</ColumnValue>,
  },
]
